import { render, staticRenderFns } from "./FichaNodo.vue?vue&type=template&id=23e2cb59&scoped=true&"
import script from "./FichaNodo.vue?vue&type=script&lang=js&"
export * from "./FichaNodo.vue?vue&type=script&lang=js&"
import style0 from "./FichaNodo.vue?vue&type=style&index=0&id=23e2cb59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2cb59",
  null
  
)

export default component.exports